// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38bw1","label":"styles_label__3zEj2"};